export enum TenantUserStatus {
  PENDING_INVITATION,
  PENDING_ACCEPTANCE,
  ACTIVE,
  INACTIVE,
}
